export const formatEmployeeId = (employeeId: string) => {
  if (employeeId?.length === 12) {
    return `${employeeId.slice(0, 8)}-${employeeId.slice(8, 12)}`;
  }

  return employeeId;
};
